import React from "react";

// Shared "Page not found" screen. Reused as the IP-revocation overlay so an
// unauthorized IP sees the exact same screen the platform/firm login gate shows.
export default function PageNotFound() {
  return (
    <div
      className="fixed inset-0 z-[9999] min-h-screen bg-[#0b0d10] flex flex-col items-center justify-center gap-2 text-center px-6"
      data-testid="page-not-found"
    >
      <span className="font-editorial text-4xl text-white">Page not found</span>
      <span className="text-white/50 text-[14px]">The page you're looking for doesn't exist.</span>
    </div>
  );
}
